export enum PATHS {
  Home = '/',
  LoginCallback = '/loginCallback',
  Admin = '/admin'
}
